import Modal from '../../../../commons/Modal/Modal';
import Button from '../../../../designSystem/Button/Button';
import { LoginPUBModalProps } from './LoginPUBModal.types';

export default (props: LoginPUBModalProps) => {
  return (
    <Modal {...props}>
      <h2>Merci de votre inscription</h2>
      <p>Votre inscription a bien été prise en compte</p>
      <a href="/">
        <Button style={{ marginTop: 'var(--spacing-sToM)' }}>Retour à l'accueil</Button>
      </a>
    </Modal>
  );
};
